export default __webpack_public_path__ + "static/0098-9d528fe27f77a5b425068bbc375b963b.png";